import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { Toaster } from "./components/ui/sonner";
import { ProtectedRoute } from "./components/ProtectedRoute";

// Pages
import LandingPage from "./pages/LandingPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import DashboardPage from "./pages/DashboardPage";
import PlayersPage from "./pages/PlayersPage";
import NeedsPage from "./pages/NeedsPage";
import AddPlayerPage from "./pages/AddPlayerPage";
import AddNeedPage from "./pages/AddNeedPage";
import AddInterestPage from "./pages/AddInterestPage";
import MyPublicationsPage from "./pages/MyPublicationsPage";
import PlayerDetailPage from "./pages/PlayerDetailPage";
import NeedDetailPage from "./pages/NeedDetailPage";

// Admin Pages
import AdminDashboardPage from "./pages/admin/AdminDashboardPage";
import AdminClubsPage from "./pages/admin/AdminClubsPage";
import AdminPlayersPage from "./pages/admin/AdminPlayersPage";
import AdminNeedsPage from "./pages/admin/AdminNeedsPage";
import AdminInterestsPage from "./pages/admin/AdminInterestsPage";

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <Toaster position="top-right" richColors />
        <BrowserRouter>
          <Routes>
            {/* Public routes */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />

            {/* Protected routes - Clubs */}
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <DashboardPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/players"
              element={
                <ProtectedRoute>
                  <PlayersPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/players/:id"
              element={
                <ProtectedRoute>
                  <PlayerDetailPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/needs"
              element={
                <ProtectedRoute>
                  <NeedsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/needs/:id"
              element={
                <ProtectedRoute>
                  <NeedDetailPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/add-player"
              element={
                <ProtectedRoute>
                  <AddPlayerPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/add-need"
              element={
                <ProtectedRoute>
                  <AddNeedPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/add-interest"
              element={
                <ProtectedRoute>
                  <AddInterestPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/my-publications"
              element={
                <ProtectedRoute>
                  <MyPublicationsPage />
                </ProtectedRoute>
              }
            />

            {/* Admin routes */}
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminDashboardPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/clubs"
              element={
                <ProtectedRoute>
                  <AdminClubsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/players"
              element={
                <ProtectedRoute>
                  <AdminPlayersPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/needs"
              element={
                <ProtectedRoute>
                  <AdminNeedsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/interests"
              element={
                <ProtectedRoute>
                  <AdminInterestsPage />
                </ProtectedRoute>
              }
            />

            {/* Fallback */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </div>
    </AuthProvider>
  );
}

export default App;
